import styled from 'styled-components';
import { getColorShade, getSizeBy, getThemeProp } from '../../../../../src/styled/utils';
import { MultiDropzone } from '../multi/styled';
import { FileCard } from '../../components/file-card';
export const SingleDropzone = styled(MultiDropzone) `
  min-height: ${getSizeBy(13)};
  padding: ${({ $hasFile }) => ($hasFile ? 0 : [getSizeBy(2), ' ', getSizeBy(7)])};
  border-color: ${getColorShade('onSurface', 'outline')};
  border-style: ${({ $hasFile }) => ($hasFile ? 'solid' : 'dashed')};
  border-width: 1px;

  & > p {
    padding: 0 ${getSizeBy(5)};
  }
`;
export const SingleUploaderFileCard = styled(FileCard) `
  border-radius: ${getThemeProp('borderRadius')}px;
`;
